/**
 * サイドバー開閉（PC・SHELL-R4）
 *
 * マークアップ規約:
 *   <button class="lms-sidebar-toggle" data-lms-sidebar-toggle aria-label="サイドバーの開閉">…</button>
 *   （トグル対象は .lms-sidebar--docked）
 *
 * 挙動（design.md D5）:
 *   - 押下で `.lms-sidebar--docked` に `is-collapsed` をトグルし、幅トランジションで開閉する
 *   - 状態はメモリのみ（永続化しない）。ボタン・サイドバーはシェル側（#lms-main の外）にあり
 *     htmx の部分更新で再描画されないため、遷移してもセッション内では自然に維持される
 */

/**
 * 左下固定ボタンを初期化する。ボタンもサイドバーもシェル側にあるため、{@code boot()} で 1
 * 度だけ呼ぶ（部分更新のたびに再初期化しない）。ボタン・サイドバーともに常に {@code document}
 * 全体から検索する（レビュー Low-4 対応: 呼び出し契約が「{@code boot()} から {@code document}
 * で 1 回だけ」であり、部分更新のたびに絞り込んだ {@code scope} を渡す使い方がないため、
 * `scope` 引数は削除した）。
 */
export function initSidebarToggle(): void {
  const button = document.querySelector<HTMLElement>("[data-lms-sidebar-toggle]");
  const sidebar = document.querySelector<HTMLElement>(".lms-sidebar--docked");
  if (!button || !sidebar) return;

  button.addEventListener("click", () => {
    const collapsed = sidebar.classList.toggle("is-collapsed");
    button.classList.toggle("is-collapsed", collapsed);
    button.setAttribute("aria-expanded", String(!collapsed));
  });
}
